export const Marquee = ({ items }) => {
  const sequence = (keyPrefix) => (
    <div key={keyPrefix} className="flex shrink-0 items-center">
      {items.map((item, i) => (
        <span key={`${keyPrefix}-${item}`} className="flex items-center">
          <span
            className={`whitespace-nowrap px-8 font-display text-5xl italic tracking-tight sm:text-7xl ${
              i % 2 === 0 ? "text-bone/90" : "text-outline"
            }`}
          >
            {item}
          </span>
          <span className="h-2 w-2 rotate-45 bg-gold/70" aria-hidden="true" />
        </span>
      ))}
    </div>
  );

  return (
    <div className="relative overflow-hidden border-y border-white/5 py-8" data-testid="species-marquee">
      <div className="animate-marquee flex w-max">
        {sequence("a")}
        {sequence("b")}
      </div>
    </div>
  );
};
